import { DeleteRequest, GetRequest, PutRequest } from "../../../plugins/https";
import { addPhoto, deletePhoto, getOneGallery } from "./action";
import { ADD_PHOTOS, DELETE_PHOTO, GET_ONE_GALLERY } from "./actionType";

export const getOneGalleryData = (id) => async (dispatch) => {
  try {
    const res = await GetRequest(`/gallery/${id}`);
    dispatch(getOneGallery(res.data));
  } catch (error) {
    console.error("Error getting gallery: ", error);
  }
};

export const deleteOneImage = (id, photo) => async (dispatch) => {
  try {
    // Ensure we send an array under `removePhotos` as the backend expects
    const body = { removePhotos: Array.isArray(photo) ? photo : [photo] };
    const res = await PutRequest(`/gallery/${id}`, body);
    // After deleting on the server, refetch the gallery to keep state consistent
    dispatch(getOneGalleryData(id));
  } catch (error) {
    console.error("Error in deleting gallery: ", error);
  }
};
export const addPhotos = (Gallery, id) => async (dispatch) => {
  try {
    const res = await PutRequest(`/gallery/${id}`, Gallery);
    dispatch(addPhoto(res.data.photos)); // Ensure `res.data.photos` is the correct structure
  } catch (error) {
    console.error("Error in adding gallery: ", error);
  }
};

const initialState = {
  OneGalleryData: null,
};

export const OneGalleryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ONE_GALLERY: {
      // Some API wrappers return an object like { status, data: { ... } }
      // Normalize to always store the inner data object when present.
      const payload =
        action.payload && action.payload.data
          ? action.payload.data
          : action.payload;
      return {
        ...state,
        OneGalleryData: payload,
      };
    }
    case DELETE_PHOTO: {
      if (!state.OneGalleryData || !Array.isArray(state.OneGalleryData.photos))
        return state;
      return {
        ...state,
        OneGalleryData: {
          ...state.OneGalleryData,
          photos: state.OneGalleryData.photos.filter(
            (photo) => photo._id !== action.payload.photo._id,
          ),
        },
      };
    }
    case ADD_PHOTOS: {
      const existing =
        state.OneGalleryData && Array.isArray(state.OneGalleryData.photos)
          ? state.OneGalleryData.photos
          : [];
      const toAdd = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      return {
        ...state,
        OneGalleryData: {
          ...state.OneGalleryData,
          photos: [...existing, ...toAdd],
        },
      };
    }
    default:
      return state;
  }
};
